// @flow

import type {ApiSuccess} from '@travel-frontend/state-handling-sdk';
import type {Formsheet} from 'redux/v1/formsheet/models';

import {ASYNC_TYPES} from '@travel-frontend/state-handling-sdk';
import axios from 'axios';

import {config as cfg} from 'config';

export const FETCH_FORMSHEET = 'v1/journey/FETCH_FORMSHEET';

export type FetchFormsheetSuccess = ApiSuccess<Formsheet, *>;

// $FlowFixMe
export function fetchFormsheet(journeyId: number, token: string) {
  const config = {
    headers: {Authorization: `Bearer ${token}`},
  };
  return {
    types: ASYNC_TYPES(FETCH_FORMSHEET),
    callAPI: () =>
      axios
        .get(`${cfg.bookingServiceUrl}/formsheet/${journeyId}/11`, config)
        .then((res) => res.data.form),
  };
}
